import React, { useMemo } from 'react';
import './index.less';
import { formatNum } from '@cap/share/src/utils/number';
import { ENU_COURSE_TYPE } from '@/utils/course';

interface PersonProps {
  viewCount: number;
  type: number;
}
const Person: React.FC<PersonProps> = ({ viewCount, type }) => {
  const personCountDisplay = useMemo(() => {
    const { num, unit } = formatNum(viewCount);
    const displayText = `${num}${unit}${unit ? '+' : ''}`;
    const arr = [ENU_COURSE_TYPE.CERTIFY, ENU_COURSE_TYPE.TRAINING];

    return (arr.indexOf(type) !== -1 ? `${viewCount} 人看过` : `${viewCount} 人学过`).replace(
      viewCount.toString(),
      displayText,
    );
  }, [viewCount, type]);

  return <div className="person-left">{personCountDisplay}</div>;
};

export default Person;
